module.exports = __webpack_public_path__ + "static/selenium-a47c8c7aa24a98d828dc654af31f0fc5.svg";